import React from 'react';
import { jumpTo } from '@/navigate'
import { toJS } from 'mobx'
import { inject, observer } from "mobx-react";
import Tips from "../../components/tips";
import Msg from "../../components/message";
import BgAudio from "./bgAudio";
import './index.scss';
@inject("ScoreStore")
@observer
class App extends React.Component {
    state = {
        operable: false,
        audioTime: 0,
        subTime: 0,
        name: "",
        type: "",
        errorMsg: ""
    }
    valueChange(e) {
        let target = e.currentTarget;
        this.setState({
            [target.name]: target.value,
            errorMsg: ""
        })
    }
    jumpPage() {
        if (!this.state.name) {
            return false;
        }
        this.setState({
            subTime: this.state.subTime + 1
        }, () => {
            let classInfo = this.props.ScoreStore.classInfo;
            let classType = toJS(classInfo.classType);
            if (classType.indexOf(this.state.type) != -1 && this.state.subTime == 1) {
                this.props.ScoreStore.addScore(3)
            }
            else {
                this.props.ScoreStore.setPenalties("现病史诊断", 3)
            }
            if (this.state.name != classInfo.className && this.state.name != classInfo.className_ed) {
                this.setState({
                    errorMsg: "诊断病名错误"
                })
                return false;
            }
            else {
                if (this.state.subTime == 1) {
                    if (this.state.name == classInfo.className) {
                        this.props.ScoreStore.addScore(3)
                    }
                    else {
                        this.props.ScoreStore.addScore(1)
                        this.props.ScoreStore.setPenalties("现病史诊断", 2)
                    }

                }
            }
            jumpTo("guide4")
        })
    }
    tipsCallBack() {
        this.setState({
            audioTime: this.state.audioTime + 1
        }, () => {
            if (this.state.audioTime == 1) {
                this.stepAudio.play();
            }

        })

    }
    render() {
        return (
            <div className="page page-guide guide_room">
                <div className="room_name">就诊室</div>
                <div className="form_view">
                    <div className="form_tit">现病史诊断</div>
                    <div className="form_bd">
                        <div className="form_item">
                            <label>中医病名</label>
                            <div><input placeholder="请输入中医病名" autoComplete="off" value={this.state.name} name="name" onChange={(e) => { this.valueChange(e) }} /></div>
                        </div>
                        <div className="form_item">
                            <label>辨证分型</label>
                            <div><input placeholder="请输入辨证类型" autoComplete="off" value={this.state.type} name="type" onChange={(e) => { this.valueChange(e) }} /></div>
                        </div>

                    </div>
                    <div className="form_btn" >
                        <button className={!this.state.name ? "disabled" : ""} onClick={() => { this.jumpPage() }}>确定</button>
                    </div>
                </div>
                <audio ref={(e) => { this.stepAudio = e }} src={require("../../assets/audio/step_3.mp3")} />
                <Msg msg={this.state.errorMsg} />
                <Tips init={true} callBack={() => { this.tipsCallBack() }} studyTips={0} />
                <BgAudio />
            </div>
        );
    }
}

export default App;
